import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../components'
import { Box } from '@mui/material';

const AbonosAdminTabScreen = () => {
  const navigate = useNavigate();

  return (
    <Box mt={-2}>
      <CustomTab
        base={'/abonos/admin'}
        panels={[
          {
            name: "Notificaciones",
            route: '/abonos/admin/notificaciones',
            onChange: () => navigate('notificaciones'),
            content: <Outlet />
          },
          {
            name: "Historial",
            route: '/abonos/admin/historial',
            onChange: () => navigate('historial'),
            content: <Outlet />
          },
          {
            name: "Cuentas",
            route: '/abonos/admin/cuentas',
            onChange: () => navigate('cuentas'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default AbonosAdminTabScreen